import { Box, Theme, Typography } from "@mui/material";
import React, { ReactElement } from "react";

export interface FieldsetProps {
  children: ReactElement;
  legend: ReactElement | string;
  prefix?: ReactElement | string;
  helpComponent?: ReactElement | null;
  hint?: ReactElement | string;
}

export const Fieldset: React.FC<FieldsetProps> = ({
  children,
  legend,
  prefix,
  helpComponent = null,
  hint = null,
}) => {
  const hintComponent = hint && <Box marginBottom="10px">{hint}</Box>;

  return (
    <fieldset
      style={{
        padding: 0,
        margin: 0,
        border: "none",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignContent="center"
      >
        <Typography
          component="legend"
          sx={(theme: Theme) => ({
            color: theme.palette.common.black,
            fontSize: "1.09rem",
            whiteSpace: "initial",
          })}
        >
          <Typography
            component="div"
            sx={(theme: Theme) => ({
              color: theme.palette.common.black,
              fontSize: ".9rem",
              whiteSpace: "initial",
              paddingBottom: 3,
            })}
          >
            {prefix}
          </Typography>
          {legend}
        </Typography>
        {helpComponent}
      </Box>
      {hintComponent}
      {children}
    </fieldset>
  );
};
